import { render, staticRenderFns } from "./SidebarSettingsMobileOld.vue?vue&type=template&id=17037769&"
import script from "./SidebarSettingsMobileOld.vue?vue&type=script&lang=js&"
export * from "./SidebarSettingsMobileOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports